import './LinksBar.css';
import * as React from 'react';
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import LinksBarButton from "./LinksBarButton";
import {withRouter} from "react-router-dom";

class LinksBar extends React.Component {

  bar = React.createRef();
  leftPaddle = React.createRef();
  rightPaddle = React.createRef();

  componentDidMount() {
    if (this.props.self) {
      this.props.self.current = this;
    }

    this.listener = this.refreshPaddle.bind(this);
    window.addEventListener('resize', this.listener);
    this.scrollIntoView();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    this.listener();
    this.scrollIntoView();
  }

  scrollIntoView() {
    const activeElement = this.bar.current.getElementsByClassName("active");

    if (activeElement.length) {
      const element = activeElement[0];
      const parent = element.parentElement;
      const centerPosition = element.offsetLeft - (parent.getBoundingClientRect().width - element.getBoundingClientRect().width) / 2;
      parent.scrollTo({left: centerPosition, behavior: 'smooth'});
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.listener);
  }

  scrollLeft() {
    this.bar.current.scrollLeft -= (this.bar.current.parentNode.offsetWidth - 180);
  }

  scrollRight() {
    this.bar.current.scrollLeft += (this.bar.current.parentNode.offsetWidth - 180);
  }

  refreshPaddle() {
    const scrollLeft = this.bar.current.scrollLeft;
    const scrollPosition = scrollLeft + this.bar.current.parentNode.offsetWidth;

    if (scrollLeft === 0) {
      this.leftPaddle.current.classList.add("hidden");
    } else {
      this.leftPaddle.current.classList.remove("hidden");
    }

    if (scrollPosition >= this.bar.current.scrollWidth) {
      this.rightPaddle.current.classList.add("hidden");
    } else {
      this.rightPaddle.current.classList.remove("hidden");
    }
  }

  render() {
    return (
        <React.Fragment>
          {this.props.title &&
          <div className="links-bar-title">{this.props.title}:</div>
          }
          <div className="links-bar-wrapper">
            <div ref={this.bar} className="links-bar" onScroll={this.refreshPaddle.bind(this)}>
              {this.props.links?.map((config) => {
                return <LinksBarButton key={config.label} component={config.component} value={config.value} callback={this.props.callback} queryParam={this.props.queryParam} label={config.label} removePadding={config.removePadding} selectedValue={this.props.selectedValue}  />
              })}
            </div>

            <div className="paddles">
              <button ref={this.leftPaddle} className="left-paddle paddle hidden" onClick={this.scrollLeft.bind(this)}>
                <NavigateBeforeIcon/>
              </button>
              <button ref={this.rightPaddle} className="right-paddle paddle" onClick={this.scrollRight.bind(this)}>
                <NavigateNextIcon/>
              </button>
            </div>
          </div>
        </React.Fragment>
    );
  }
}

export default withRouter(LinksBar);
